// Generic host events are prefixed with acv:
export const HOST_EVENT_PREFIX = 'acv:';

export const FEATURE_FLAGS_CHANGED = 'feature-flags-changed';
export const FEATURE_FLAGS_REQUEST = 'feature-flags-request';

// Any MFE listening for `acv:<topic>` on window receives the payload as event.detail
const broadcastHostEvent = (topic, payload) => {
  window.dispatchEvent(new CustomEvent(`${HOST_EVENT_PREFIX}${topic}`, { detail: payload }));
};

export default broadcastHostEvent;
